import { HorizontalDivider, VerticalDivider } from "@@/shared/dividers";
import { usePageBreakpoint } from "@@/shared/responsiveness/use-page-breakpoint";
import { SectionArea } from "@@/shared/section-area";
import { SectionAreaList } from "@@/shared/section-area/section-area-list";
import { useProductIdWithFallback } from "@@/store-fronts/shared/fallback-product-ids";
import type { ProductId, RemSize} from "@towni/common";
import { translation } from "@towni/common";
import * as React from "react";
import { ResponsiveStoreFrontHzProductCard } from "../../shared/store-front-hz-product-card";
import { kronocampingColors } from "../kronocamping-color-context";

const KronocampingMoreForYouthSection = () => {
    const isDesktop = usePageBreakpoint({ when: "🖥" });
    const getProductId = useProductIdWithFallback();

    const productIds = React.useMemo(
        () => [
            //  Padeltennis - spelat tidigare
            getProductId("product__6NlsefFKrOxdLcTjtxTl" as ProductId),

            // Äventyrsgolf med barnklubben
            getProductId("product__U6rN6emXQV-Aa3ih-S_" as ProductId),

            // Filmtajm
            getProductId("product_axmATGhH2I79h2aAadzo" as ProductId),
            // Äventyrsgolf med barnklubben
            getProductId("product_qQCc7h638b74y360I-mR" as ProductId),
        ],
        []
    );

    return (
        <SectionArea
            sectionAreaId="kronocamping-more-for-the-youth"
            title="Mer för de unga"
            titleSize={2 as RemSize}
            subtitle="Vi har mycket för att göra din vistelse full av liv och rörelse"
            background={{
                color: kronocampingColors.lightBackground,
            }}
            css={{
                borderRadius: isDesktop ? 10 : 0,
            }}
            padding={isDesktop ? { all: 10 } : { topBottom: 10 }}>
            <SectionAreaList
                scroll={true}
                contentMargin={15}
                padding={{
                    bottom: 20,
                    left: 20,
                }}>
                <ResponsiveStoreFrontHzProductCard
                    cardSize={1.35 as RemSize}
                    productId={productIds[0]}
                    actionText={text.explore}
                    actionTextColorSet={kronocampingColors.secondary}
                    aspectRatio="3:4"
                    subtitleSize={0.93 as RemSize}
                    hideKicker
                />
                <ResponsiveStoreFrontHzProductCard
                    cardSize={1.35 as RemSize}
                    reversed
                    productId={productIds[1]}
                    actionText={text.seeMore}
                    actionTextColorSet={kronocampingColors.secondary}
                    aspectRatio="3:4"
                    subtitleSize={0.93 as RemSize}
                    hideKicker
                />
                <ResponsiveStoreFrontHzProductCard
                    cardSize={1.35 as RemSize}
                    productId={productIds[2]}
                    actionText={text.book}
                    actionTextColorSet={kronocampingColors.primary}
                    aspectRatio="3:4"
                    subtitleSize={0.93 as RemSize}
                    hideKicker
                />
                <ResponsiveStoreFrontHzProductCard
                    cardSize={1.35 as RemSize}
                    productId={productIds[3]}
                    reversed
                    actionText={text.book}
                    actionTextColorSet={kronocampingColors.secondary}
                    aspectRatio="3:4"
                    subtitleSize={0.93 as RemSize}
                    hideKicker
                />
                <HorizontalDivider size="L" />
            </SectionAreaList>
            <VerticalDivider M />
        </SectionArea>
    );
};

const text = {
    explore: translation({
        sv: "Utforska",
        en: "Explore",
    }),
    seeMore: translation({
        sv: "Se mer",
        en: "See more",
    }),
    book: translation({
        sv: "Boka",
        en: "Book",
    }),
};

export { KronocampingMoreForYouthSection };
